(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-contact-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var faqItems = document.querySelectorAll('[data-pv-faq-item]');
    faqItems.forEach(function (item) {
      var toggle = item.querySelector('[data-pv-faq-toggle]');
      toggle.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-petvona-home"]) return;
  try {
    
  if (!customElements.get('pv-hero-slider')) {
    customElements.define(
      'pv-hero-slider',
      class PvHeroSlider extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-pv-hero-slide]'));
          this.dotsWrap = this.querySelector('[data-pv-hero-dots]');
          this.current = 0;
          this.timer = null;

          if (this.slides.length < 2) return;

          this.slides.forEach((slide, index) => {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pv-hero__dot' + (index === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Slide ' + (index + 1));
            dot.addEventListener('click', this.goTo.bind(this, index));
            this.dotsWrap.appendChild(dot);
          });
          this.dots = Array.from(this.dotsWrap.querySelectorAll('.pv-hero__dot'));

          var prevBtn = this.querySelector('[data-pv-hero-prev]');
          var nextBtn = this.querySelector('[data-pv-hero-next]');
          if (prevBtn) prevBtn.addEventListener('click', this.prev.bind(this));
          if (nextBtn) nextBtn.addEventListener('click', this.next.bind(this));

          if (this.dataset.autoplay === 'true') {
            this.startAutoplay();
            this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
            this.addEventListener('mouseleave', this.startAutoplay.bind(this));
          }
        }

        goTo(index) {
          this.slides[this.current].classList.remove('is-active');
          this.dots[this.current].classList.remove('is-active');
          this.current = index;
          this.slides[this.current].classList.add('is-active');
          this.dots[this.current].classList.add('is-active');
        }

        next() {
          this.goTo((this.current + 1) % this.slides.length);
        }

        prev() {
          this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
        }

        startAutoplay() {
          var speed = parseInt(this.dataset.autoplaySpeed, 10) || 6;
          this.stopAutoplay();
          this.timer = setInterval(this.next.bind(this), speed * 1000);
        }

        stopAutoplay() {
          if (this.timer) clearInterval(this.timer);
        }
      }
    );
  }

  // ===== Video showcase: slider arrows, dots, duration tags, modal =====
  var pvVideoGrid = document.querySelector('[data-pv-video-grid]');

  if (pvVideoGrid) {
    var pvVideoCards = Array.prototype.slice.call(pvVideoGrid.querySelectorAll('[data-pv-video-open]'));
    var pvVideoSources = pvVideoCards.map(function (card) { return card.getAttribute('data-video-src'); });

    // Auto-fill duration tags from real video metadata
    pvVideoGrid.querySelectorAll('[data-pv-video-preview]').forEach(function (video) {
      video.addEventListener('loadedmetadata', function () {
        var tag = video.closest('[data-pv-video-open]').querySelector('[data-pv-video-duration]');
        if (tag && isFinite(video.duration)) {
          var totalSec = Math.round(video.duration);
          var mins = Math.floor(totalSec / 60);
          var secs = totalSec % 60;
          tag.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
        }
      });
    });

    // Slider arrows
    var pvVideoPrevBtn = document.querySelector('[data-pv-video-prev]');
    var pvVideoNextBtn = document.querySelector('[data-pv-video-next]');
    if (pvVideoPrevBtn && pvVideoNextBtn) {
      pvVideoPrevBtn.addEventListener('click', function () {
        pvVideoGrid.scrollBy({ left: -pvVideoGrid.clientWidth * 0.8, behavior: 'smooth' });
      });
      pvVideoNextBtn.addEventListener('click', function () {
        pvVideoGrid.scrollBy({ left: pvVideoGrid.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    // Pagination dots (one per "screen" of the slider)
    var pvVideoDotsWrap = document.querySelector('[data-pv-video-dots]');
    function renderPvVideoDots() {
      if (!pvVideoDotsWrap) return;
      var pageCount = Math.max(1, Math.round(pvVideoGrid.scrollWidth / pvVideoGrid.clientWidth));
      pvVideoDotsWrap.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pv-video-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('data-page', i);
        dot.addEventListener('click', function () {
          var page = parseInt(this.getAttribute('data-page'), 10);
          pvVideoGrid.scrollTo({ left: page * pvVideoGrid.clientWidth, behavior: 'smooth' });
        });
        pvVideoDotsWrap.appendChild(dot);
      }
    }
    renderPvVideoDots();
    window.addEventListener('resize', renderPvVideoDots);

    var pvVideoScrollTimer;
    pvVideoGrid.addEventListener('scroll', function () {
      clearTimeout(pvVideoScrollTimer);
      pvVideoScrollTimer = setTimeout(function () {
        if (!pvVideoDotsWrap) return;
        var activePage = Math.round(pvVideoGrid.scrollLeft / pvVideoGrid.clientWidth);
        pvVideoDotsWrap.querySelectorAll('.pv-video-dot').forEach(function (dot, i) {
          dot.classList.toggle('active', i === activePage);
        });
      }, 100);
    });

    // Auto-advance the slider
    var pvVideoAutoplayTimer;
    function pvVideoAutoAdvance() {
      var atEnd = pvVideoGrid.scrollLeft + pvVideoGrid.clientWidth >= pvVideoGrid.scrollWidth - 4;
      if (atEnd) {
        pvVideoGrid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        pvVideoGrid.scrollBy({ left: pvVideoGrid.clientWidth * 0.8, behavior: 'smooth' });
      }
    }
    function pvVideoStartAutoplay() {
      pvVideoStopAutoplay();
      pvVideoAutoplayTimer = setInterval(pvVideoAutoAdvance, 3500);
    }
    function pvVideoStopAutoplay() {
      clearInterval(pvVideoAutoplayTimer);
    }
    pvVideoStartAutoplay();
    pvVideoGrid.addEventListener('mouseenter', pvVideoStopAutoplay);
    pvVideoGrid.addEventListener('mouseleave', pvVideoStartAutoplay);
    pvVideoGrid.addEventListener('touchstart', pvVideoStopAutoplay, { passive: true });

    // Modal
    var pvVideoModal = document.querySelector('[data-pv-video-modal]');
    if (pvVideoModal) {
      var pvVideoModalPlayer = pvVideoModal.querySelector('[data-pv-video-modal-player]');
      var pvVideoModalProgress = pvVideoModal.querySelector('[data-pv-video-modal-progress]');
      var pvPlayPauseBtn = pvVideoModal.querySelector('[data-pv-video-playpause]');
      var pvMuteBtn = pvVideoModal.querySelector('[data-pv-video-mute]');
      var pvIconPause = pvVideoModal.querySelector('[data-pv-icon-pause]');
      var pvIconPlay = pvVideoModal.querySelector('[data-pv-icon-play]');
      var pvIconVolumeHigh = pvVideoModal.querySelector('[data-pv-icon-volume-high]');
      var pvIconVolumeMute = pvVideoModal.querySelector('[data-pv-icon-volume-mute]');
      var pvCurrentVideoIndex = 0;

      function pvUpdatePlayPauseIcon(isPlaying) {
        pvIconPause.style.display = isPlaying ? 'block' : 'none';
        pvIconPlay.style.display = isPlaying ? 'none' : 'block';
      }

      function pvUpdateVolumeIcon() {
        pvIconVolumeHigh.style.display = pvVideoModalPlayer.muted ? 'none' : 'block';
        pvIconVolumeMute.style.display = pvVideoModalPlayer.muted ? 'block' : 'none';
      }

      function pvLoadModalVideo() {
        pvVideoModalPlayer.src = pvVideoSources[pvCurrentVideoIndex];
        pvVideoModalPlayer.muted = false;
        pvUpdateVolumeIcon();

        var playPromise = pvVideoModalPlayer.play();
        if (playPromise !== undefined) {
          playPromise.then(function () {
            pvUpdatePlayPauseIcon(true);
          }).catch(function () {
            pvVideoModalPlayer.muted = true;
            pvUpdateVolumeIcon();
            pvVideoModalPlayer.play();
            pvUpdatePlayPauseIcon(true);
          });
        }
      }

      function openPvVideoModal(index) {
        pvCurrentVideoIndex = index;
        pvLoadModalVideo();
        pvVideoModal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }

      function closePvVideoModal() {
        pvVideoModalPlayer.pause();
        pvVideoModalPlayer.removeAttribute('src');
        pvVideoModal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }

      function pvNextModalVideo(e) {
        if (e) e.stopPropagation();
        pvCurrentVideoIndex = (pvCurrentVideoIndex + 1) % pvVideoSources.length;
        pvLoadModalVideo();
      }

      function pvPrevModalVideo(e) {
        if (e) e.stopPropagation();
        pvCurrentVideoIndex = (pvCurrentVideoIndex - 1 + pvVideoSources.length) % pvVideoSources.length;
        pvLoadModalVideo();
      }

      pvVideoCards.forEach(function (card, index) {
        card.addEventListener('click', function () { openPvVideoModal(index); });
      });

      pvVideoModal.querySelectorAll('[data-pv-video-close]').forEach(function (btn) {
        btn.addEventListener('click', closePvVideoModal);
      });

      var pvModalNextBtn = pvVideoModal.querySelector('[data-pv-video-modal-next]');
      var pvModalPrevBtn = pvVideoModal.querySelector('[data-pv-video-modal-prev]');
      if (pvModalNextBtn) pvModalNextBtn.addEventListener('click', pvNextModalVideo);
      if (pvModalPrevBtn) pvModalPrevBtn.addEventListener('click', pvPrevModalVideo);

      if (pvPlayPauseBtn) {
        pvPlayPauseBtn.addEventListener('click', function () {
          if (pvVideoModalPlayer.paused) {
            pvVideoModalPlayer.play();
            pvUpdatePlayPauseIcon(true);
          } else {
            pvVideoModalPlayer.pause();
            pvUpdatePlayPauseIcon(false);
          }
        });
      }

      if (pvMuteBtn) {
        pvMuteBtn.addEventListener('click', function () {
          pvVideoModalPlayer.muted = !pvVideoModalPlayer.muted;
          pvUpdateVolumeIcon();
        });
      }

      pvVideoModalPlayer.addEventListener('timeupdate', function () {
        if (pvVideoModalPlayer.duration && pvVideoModalProgress) {
          var pct = (pvVideoModalPlayer.currentTime / pvVideoModalPlayer.duration) * 100;
          pvVideoModalProgress.style.width = pct + '%';
        }
      });

      document.addEventListener('keydown', function (event) {
        if (pvVideoModal.hasAttribute('hidden')) return;
        if (event.key === 'Escape') closePvVideoModal();
        if (event.key === 'ArrowRight') pvNextModalVideo();
        if (event.key === 'ArrowLeft') pvPrevModalVideo();
      });
    }
  }

  // Top Picks — add to cart
  var pvProductGrid = document.querySelector('[data-pv-product-grid]');
  if (pvProductGrid) {
    pvProductGrid.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-add-cart-variant]');
      if (!btn) return;

      event.preventDefault();
      var variantId = btn.getAttribute('data-add-cart-variant');
      if (!variantId) return;

      btn.style.transform = 'scale(0.85)';
      setTimeout(function () { btn.style.transform = ''; }, 200);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
            return data;
          });
        })
        .then(function () {
          if (window.pvOpenCartDrawer) window.pvOpenCartDrawer();
        })
        .catch(function (err) {
          console.error('Cart add error:', err);
          alert(err.message || 'Could not add this product to your cart.');
        });
    });
  }

  // Top Picks slider (arrows only)
  var pvPicksTrack = document.querySelector('[data-pv-product-grid]');
  if (pvPicksTrack && pvPicksTrack.children.length) {
    var pvPicksPrevBtn = document.querySelector('[data-pv-picks-prev]');
    var pvPicksNextBtn = document.querySelector('[data-pv-picks-next]');

    if (pvPicksPrevBtn) {
      pvPicksPrevBtn.addEventListener('click', function () {
        pvPicksTrack.scrollBy({ left: -pvPicksTrack.clientWidth * 0.9, behavior: 'smooth' });
      });
    }
    if (pvPicksNextBtn) {
      pvPicksNextBtn.addEventListener('click', function () {
        pvPicksTrack.scrollBy({ left: pvPicksTrack.clientWidth * 0.9, behavior: 'smooth' });
      });
    }
  }

  // Testimonials carousel
  var pvTestTrack = document.querySelector('[data-pv-test-track]');
  if (pvTestTrack) {
    var pvTestCards = Array.prototype.slice.call(pvTestTrack.children);
    var pvTestDotsWrap = document.querySelector('[data-pv-test-dots]');
    var pvTestPrevBtn = document.querySelector('[data-pv-test-prev]');
    var pvTestNextBtn = document.querySelector('[data-pv-test-next]');

    pvTestCards.forEach(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pv-testimonials__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Testimonial ' + (i + 1));
      dot.addEventListener('click', function () {
        pvTestTrack.scrollTo({ left: card.offsetLeft - pvTestTrack.offsetLeft, behavior: 'smooth' });
      });
      pvTestDotsWrap.appendChild(dot);
    });
    var pvTestDots = Array.prototype.slice.call(pvTestDotsWrap.children);

    var pvTestUpdateActiveDot = function () {
      var scrollLeft = pvTestTrack.scrollLeft;
      var closestIndex = 0;
      var closestDist = Infinity;
      pvTestCards.forEach(function (card, i) {
        var dist = Math.abs((card.offsetLeft - pvTestTrack.offsetLeft) - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      pvTestDots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === closestIndex);
      });
    };

    var pvTestScrollTimer;
    pvTestTrack.addEventListener('scroll', function () {
      clearTimeout(pvTestScrollTimer);
      pvTestScrollTimer = setTimeout(pvTestUpdateActiveDot, 100);
    });

    if (pvTestPrevBtn) {
      pvTestPrevBtn.addEventListener('click', function () {
        pvTestTrack.scrollBy({ left: -pvTestTrack.clientWidth * 0.9, behavior: 'smooth' });
      });
    }
    if (pvTestNextBtn) {
      pvTestNextBtn.addEventListener('click', function () {
        pvTestTrack.scrollBy({ left: pvTestTrack.clientWidth * 0.9, behavior: 'smooth' });
      });
    }
  }

  // FAQ accordion
  var pvFaqList = document.querySelector('[data-pv-faq-list]');
  var pvFaqSide = document.querySelector('.pv-faq__side');

  var pvEqualizeFaqHeight = function () {
    if (!pvFaqList || !pvFaqSide) return;
    if (window.matchMedia('(max-width: 989px)').matches) {
      pvFaqSide.style.height = '';
      return;
    }
    pvFaqSide.style.height = pvFaqList.offsetHeight + 'px';
  };

  if (pvFaqList) {
    var pvFaqItems = Array.prototype.slice.call(pvFaqList.querySelectorAll('[data-pv-faq-item]'));
    pvFaqItems.forEach(function (item) {
      var toggle = item.querySelector('[data-pv-faq-toggle]');
      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        pvFaqItems.forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('[data-pv-faq-toggle]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
        setTimeout(pvEqualizeFaqHeight, 280);
      });
    });
  }

  pvEqualizeFaqHeight();
  window.addEventListener('load', pvEqualizeFaqHeight);
  window.addEventListener('resize', pvEqualizeFaqHeight);

  } catch(e) { console.error(e); }
})();
})();
